import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskEditorComponent } from './task-editor.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { CheckboxModule } from 'primeng/checkbox';
import { DatePickerModule } from 'primeng/datepicker';

import { TaskEditorStateModule } from './task-editor.state.module';
import { DynamicDialogModule } from 'primeng/dynamicdialog';

import { ToastModule } from 'primeng/toast';
import { ListboxModule } from 'primeng/listbox';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

import {InputTextModule} from 'primeng/inputtext';
import { DialogModule } from 'primeng/dialog';

import {FileUploadModule} from 'primeng/fileupload';
import { ToolbarModule } from 'primeng/toolbar';
import { MultiSelectModule } from 'primeng/multiselect';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MessageService } from 'primeng/api';
import { PopoverModule } from 'primeng/popover';
import { TextareaModule } from 'primeng/textarea';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SelectModule,
        CheckboxModule,
        TaskEditorStateModule,
        ButtonModule,
        DynamicDialogModule,
        DatePickerModule,
        TextareaModule,
        ToastModule,
        ListboxModule,
        TableModule,
        TooltipModule,
        ProgressSpinnerModule,
        PopoverModule ,
        InputTextModule,
        DialogModule,
        FileUploadModule,
        ToolbarModule,
        MultiSelectModule,
        NgxChartsModule
    ],
    providers: [MessageService],
    exports: [TaskEditorComponent],
    declarations: [TaskEditorComponent]
})

export class TaskEditorModule { }
